import { z } from 'zod'
import { Timestamp } from './common.js'

// MeContribution — a single entry in the authenticated user's contribution
// history. v1 only surfaces "route_created" entries (one per route they
// created); future revisions can fold in suggestion / review activity once
// those collections grow real signal.

export const MeContributionAction = z.enum(['route_created'])
export type MeContributionAction = z.infer<typeof MeContributionAction>

export const MeContribution = z.object({
  id: z.string(),
  action: MeContributionAction,
  route_id: z.string().uuid(),
  route_slug: z.string(),
  route_title: z.string(),
  created_at: Timestamp,
})
export type MeContribution = z.infer<typeof MeContribution>

export const MeContributionListResponse = z.object({
  items: z.array(MeContribution),
  total: z.number().int().nonnegative(),
})
export type MeContributionListResponse = z.infer<typeof MeContributionListResponse>
